import type { Edge, Node } from 'react-flow-renderer';

import type { EdgeData, JourneyVersion, NodeData } from '../types';


export interface JourneyBuilderState {
  edgesQueue?: Edge<EdgeData>[];
  eligibleNodeConnections?: {
    sourceId: string;
    oldTargetId: string;
    eligibleConnections: any[];
  };
  isMultiEntity: boolean;
  nodeConnectionType: string;
  nodesQueue?: Node<NodeData>[];
  overlappingEdges?: Edge[];
  overlappingNodes?: Node[];
  shouldLayout: boolean;
  showValidationErrors: boolean;
  journey: JourneyVersion;
}

export const initialState: JourneyBuilderState = {
  edgesQueue: [],
  eligibleNodeConnections: undefined,
  isMultiEntity: false,
  nodeConnectionType: '',
  nodesQueue: [],
  overlappingEdges: [],
  overlappingNodes: [],
  shouldLayout: false,
  showValidationErrors: false,
  journey: {} as JourneyVersion,
};
